module.exports = "<div>\r\n  <p *ngIf=\"(this.control.invalid && (this.control.touched  || form.submitted)); else sub_content\" class=\"text-error\">{{errorMessage(this.control)}}</p>\r\n  <p #sub_content *ngIf=\"this.subControl && this.control.valid && this.subControl.invalid && (this.subControl.touched || form.submitted); else other_content\" class=\"text-error\">{{errorMessage(this.subControl)}}</p>\r\n</div>\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// D:/TMB/TMB/MYTMB.UI/src/app/components/form/message/message.component.html
// module id = ../../../../../src/app/components/form/message/message.component.html
// module chunks = main